// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  DataGridPro,
  DataGridProps,
  GridSlotsComponentsProps,
  GridToolbarContainer,
  GridToolbarFilterButton,
  useGridApiRef,
  gridExpandedSortedRowIdsSelector,
  GridColumnHeaderFilterIconButton,
  GridToolbarColumnsButton,
  GridToolbarQuickFilter,
  SearchBar,
  GridLogicOperator,
  GridFilterPanel,
  GridColumnMenuFilterItem,
  GridFilterModel,
  LicenseInfo,
} from "@mui/x-data-grid-pro";
import InputLabel from "@mui/material/InputLabel";
import "./index.css";
import { downloadExcel } from "../../../util/downloadExcel";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from "@mui/material";
import { FileDownloadOutlined, Clear, SearchOff, Widgets } from "@mui/icons-material";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import React, { FunctionComponent, useEffect, useMemo } from "react";
import SearchIcon from "@mui/icons-material/Search";
import WorkIcon from '@mui/icons-material/Work';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import { NoDataIllustration } from "../../../assets/icons";

export type TableProps = DataGridProps & {
  components?: GridSlotsComponentsProps;
  onDownload?: () => void;
  exportFileName?: string;
  onSave?: () => any;
  isMasterDetailActive?: boolean;
  masterDetailContent?: ((params: GridRowParams<any>) => React.ReactNode) | undefined;
  masterDetailHeight?: ((params: GridRowParams<any>) => number | "auto") | undefined;
  isRowExpandable?: boolean;
  showMerchantBulkPortolioButton?: boolean;
  extraLeftButtons?: React.ReactNode;
  showInternalUsersToggle?: boolean;
  internalUsersToggleValue?: boolean;
  onInternalUsersToggleChange?: (value: boolean) => void;
};

interface IColumn {
  headerName?: string;
  field: string;
}

export function FilterMenuIcon() {
  return <SearchIcon className="icon" />;
}

function CustomToolbar({
  onDownload,
  onClear,
  selectedRows,
  showBulkPayButton,
  openDialog,
  hasActiveFilters,
  extraButtons,
  extraLeftButtons,
  showMerchantBulkPortolioButton,
  showInternalUsersToggle,
  internalUsersToggleValue,
  onInternalUsersToggleChange,
}: {
  onDownload: any;
  onClear: any;
  selectedRows: any;
  showBulkPayButton: any;
  openDialog: any;
  hasActiveFilters: any;
  extraButtons?: any;
  showMerchantBulkPortolioButton: any;
  extraLeftButtons?: any;
  showInternalUsersToggle?: boolean;
  internalUsersToggleValue?: boolean;
  onInternalUsersToggleChange?: (value: boolean) => void;
}) {
  return (
    <GridToolbarContainer
      sx={{ display: "flex", justifyContent: "space-between" }}
    >
      <div>
        {showBulkPayButton && (
          <Button
            startIcon={<MonetizationOnIcon />}
            onClick={() => openDialog(true)}
            disabled={selectedRows?.length === 0}
          >
            Öde
          </Button>
        )}
        {showMerchantBulkPortolioButton && (
          <Button
            startIcon={<WorkIcon />}
            onClick={() => openDialog(true)}
            disabled={(selectedRows?.length ?? 0) === 0}
          >
            Portföy Atama
          </Button>
        )}
        {extraLeftButtons}
        {showInternalUsersToggle && (
          <Box sx={{ display: "flex", alignItems: "center", mr: 2 }}>
            <input
              type="radio"
              id="showInternalUsers"
              name="showInternalUsers"
              checked={Boolean(internalUsersToggleValue)}
              readOnly
              onClick={(e) => {
                e.preventDefault();
                onInternalUsersToggleChange?.(!Boolean(internalUsersToggleValue));
              }}
            />
            <label htmlFor="showInternalUsers" style={{ color: "#002abe", marginLeft: 4, fontWeight: "700" }}>
              İÇ KULLANICILARI GÖSTER
            </label>
          </Box>
        )}
      </div>
      <Box sx={{ display: "flex", flexWrap: "wrap", justifyContent: "end" }}>
        <GridToolbarColumnsButton />
        <Button sx={{ marginLeft: 2 }} onClick={() => onClear()} className={hasActiveFilters ? 'flashing' : ''}>
          <Clear className={hasActiveFilters ? 'flashing' : ''} />
          TEMİZLE
        </Button>
        {onDownload && (<Button sx={{ marginLeft: 2 }} onClick={onDownload}>
          <FileDownloadOutlined color="primary" />
          İNDİR
        </Button>)}
        {extraButtons}
      </Box>
    </GridToolbarContainer>
  );
}

// function formatDecimalColumns(columns) {
//   return columns.map(column => {
//     if (column.type === 'decimal') {
//       return {
//         ...column,
//         renderCell: (params) => (
//           <div>
//             {params.value != null ? `${parseFloat(params.value).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} TL` : ""}
//           </div>
//         ),
//       };
//     }
//     return column;
//   });
// }
function formatDecimalColumns(columns) {
  return columns.map((column) => {
    if (column.type === "decimal") {
      return {
        ...column,
        renderCell: (params) => {
          const currency = transformCurrency(params.row.paraBirimi || params.row.currencyDesc || params.row.paraCinsi || params.row.currency);
          return (
            <div>
              {params.value != null
                ? `${parseFloat(params.value).toLocaleString("tr-TR", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })} ${currency}`
                : `0,00 ${currency}`}
            </div>
          );
        },
      };
    } else if (column.type === "decimalOnly") {
      return {
        ...column,
        renderCell: (params) => (
          <div>
            {params.value != null
              ? parseFloat(params.value).toLocaleString("tr-TR", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
              : "0.00"}
          </div>
        ),
      };
    } else if (column.type === "decimalPercentage") {
      return {
        ...column,
        renderCell: (params) => (
          <div>
            {params.value != null
              ? `${parseFloat(params.value).toLocaleString("tr-TR", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })} %`
              : "0,00 %"}
          </div>
        ),
      };
    }

    return column;
  });
}

function transformCurrencyFromEnumId(currency) {
  switch (currency) {
    case "949":
      return "TL";
    case "840":
      return "USD"
    case "978":
      return "EUR"
    default:
      return "TL";
  }
}

function transformCurrency(currency) {
  switch (currency) {
    case "TRY":
      return "TL";
    case "USD":
      return "USD";
    case "EUR":
      return "EUR";
    default:
      return transformCurrencyFromEnumId(currency);
  }
}

function NoRowsOverlay() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        textAlign: 'center',
        p: 3,
      }}
    >
      <NoDataIllustration style={{ fontSize: 90, color: 'grey.400', width: 180, height: 'auto', marginBottom: '12px' }} />

      <Typography variant="body2" sx={{ mt: 1, color: 'grey.500', maxWidth: 320 }}>
        Görüntülenecek herhangi bir veri bulunmamaktadır.
      </Typography>
    </Box>
  );
}

export const Table = ({
  columns: originalColumns,
  filterKey,
  handleFilterChange,
  openDialog,
  selectedRows,
  showBulkPayButton,
  columnVisibilityConfigKey,
  hasActiveFilters,
  filterMode = 'server',
  extraToolbarButton,
  initialColumnVisibilityModel,
  showMerchantBulkPortolioButton,
  extraLeftButtons,
  showInternalUsersToggle = false,
  internalUsersToggleValue = false,
  onInternalUsersToggleChange,
  ...props
}: TableProps) => {
  LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_KEY);

  const formattedColumns = useMemo(
    () => formatDecimalColumns(originalColumns || []),
    [originalColumns]
  );

  const getDetailPanelContent = React.useCallback<
    NonNullable<DataGridProProps['getDetailPanelContent']>
  >(({ row }) => (row?.isRowExpanable ?? false) ? <props.masterDetailContent row={row} columns={formattedColumns} fetchData={true} /> : null, []);

  const getDetailPanelHeight = React.useCallback(() => 400, []);


  const apiRef = useGridApiRef();
  const [filterr, setFilter] = React.useState({});
  const [model, setModel] = React.useState();

  const handleDownload = () => {
    const filteredGridIds = gridExpandedSortedRowIdsSelector(apiRef);
    const fieldHeaderNameTuple = props.columns.map((column: IColumn) => {
      if (column.headerName) {
        return [column.field, column.headerName];
      }
    });

    const array = props.rows
      .filter((row) => filteredGridIds.includes(row.id))
      .map((item) => {
        const filteredItem = {};
        fieldHeaderNameTuple.map((fieldHeader) => {
          if (fieldHeader) {
            filteredItem[fieldHeader[1]] = item[fieldHeader[0]];
          }
        });

        return filteredItem;
      });

    downloadExcel(array, props?.exportFileName);
  };

  const [filters, setFilters] = React.useState({});

  const onFilterChange = React.useCallback(
    (filterModel: GridFilterModel) => {
      let newFilters = { ...filters }; // copy current filters

      filterModel.items.forEach((item) => {
        if (item.value) {
          newFilters[item.field] = item.value; // update/add new filter
        } else {
          delete newFilters[item.field]; // remove filter if no value
        }
      });

      setFilters(newFilters); // update the state
      handleFilterChange(newFilters, filterModel); // send the request with new filters
    },
    [filters]
  );

  const handleClear = () => {
    // İç kullanıcı toggle'ı açıksa, TEMİZLE ile birlikte kapat
    if (showInternalUsersToggle) {
      onInternalUsersToggleChange?.(false);
    }
    if (filterKey) {
      localStorage.removeItem(filterKey);
    }
    setFilters({});
    let propsToSend = { clearFilter: true };
    handleFilterChange(propsToSend);
  };

  const defaultModel = originalColumns?.reduce((acc, col) => {
    acc[col.field] = true;
    return acc;
  }, {});

  React.useEffect(() => {
    let storedFilters = localStorage.getItem(columnVisibilityConfigKey);
    let filtersObject = storedFilters
      ? JSON.parse(storedFilters)
      : defaultModel;

    if (storedFilters == null) {
      filtersObject = { ...defaultModel, ...initialColumnVisibilityModel };
    }

    setModel((currentModel) => ({
      ...currentModel,
      ...filtersObject,
    }));
  }, []);

  const handleColumnVisibilityChange = (newProps) => {
    // Eğer tüm değerler true ise, modeli direkt olarak yeni değerlerle güncelle
    if (Object.values(newProps).every((value) => value === true)) {
      setModel(newProps);
      localStorage.setItem(
        columnVisibilityConfigKey,
        JSON.stringify(newProps)
      );
    } else {
      setModel((currentModel) => {
        const updatedModel = {
          ...currentModel,
          ...newProps,
        };

        localStorage.setItem(
          columnVisibilityConfigKey,
          JSON.stringify(updatedModel)
        );

        return updatedModel;
      });
    }
  };

  const [key, setKey] = React.useState(Math.random());

  return (
    <Box
      sx={{
        maxHeight: "100%",
        minHeight: 400,
        width: "100%",
        maxWidth: "100%",
      }}
    >
      <DataGridPro
        {...props}
        key={key}
        apiRef={apiRef}
        pagination
        disableDensitySelector={true}
        isRowExpandable={props.isRowExpandable}
        sx={{ display: "grid" }}
        filterMode={filterMode}
        columns={formattedColumns}
        onFilterModelChange={onFilterChange}
        slots={{
          toolbar: () =>
            CustomToolbar({
              onDownload: props.onSave,
              onClear: handleClear,
              selectedRows,
              showBulkPayButton,
              openDialog,
              hasActiveFilters,
              extraButtons: extraToolbarButton,
              extraLeftButtons: extraLeftButtons,
              showMerchantBulkPortolioButton: showMerchantBulkPortolioButton,
              showInternalUsersToggle,
              internalUsersToggleValue,
              onInternalUsersToggleChange,
            }),
          columnMenuIcon: FilterMenuIcon,
          noRowsOverlay: NoRowsOverlay,
          ...props.slots,
        }}
        slotProps={{
          filterPanel: {
            filterFormProps: {
              operatorInputProps: { sx: { display: 'block' } }, // OperatÃ¶r seÃ§imini gizle
            },
          },
        }}

        localeText={{
          toolbarColumns: "Kolonlar",
          columnMenuFilter: "Filtre",
          filterPanelColumns: "Kolon",
          filterPanelInputPlaceholder: "Değer Ara",
          filterPanelOperator: "Operatör",
          filterOperatorContains: "İçerir",
          filterOperatorEquals: "Eşittir",
          filterOperatorStartsWith: "İle Başlar",
          filterOperatorEndsWith: "İle Biter",
          filterOperatorIsEmpty: "Boştur",
          filterOperatorIsNotEmpty: "Boş Değildir",
          filterOperatorIsAnyOf: "Herhangi Biri",
          filterPanelInputLabel: "Değer",
          columnMenuHideColumn: "Gizle",
          columnMenuManageColumns: "Kolonlar",
          columnMenuSortAsc: "Artan Sırala",
          columnMenuSortDesc: "Azalan Sırala",
          columnsPanelShowAllButton: "Tümünü Göster",
          columnsPanelHideAllButton: "Gizle",
          columnsPanelTextFieldLabel: "Kolon Ara",
          columnsPanelTextFieldPlaceholder: "Kolon Başlığı",
          toolbarExport: "İndir",
          toolbarExportCSV: "Excel olarak indir",
          toolbarExportPrint: "Yazdır",
          noRowsLabel: "Veri bulunamadı",
          footerRowSelected: (count) => {
            return `${count.toLocaleString()} Satır seçildi!`;
          },
          MuiTablePagination: {
            labelRowsPerPage: "Sayfa Başına Satır",
            labelDisplayedRows: ({ from, to, count }) =>
              props.customLabelDisplayedRows
                ? `(${count} veri)`
                : `${from}/${to} (${count} veri)`,
          },
        }}
        columnVisibilityModel={model}
        onColumnVisibilityModelChange={handleColumnVisibilityChange}
        rowThreshold={0}
        getDetailPanelHeight={getDetailPanelHeight}
        getDetailPanelContent={props.isMasterDetailActive ? getDetailPanelContent : null}
      ></DataGridPro>
    </Box>
  );
};